<template>
  <div class="relative flex items-center justify-center" :style="{ width: size + 'px', height: size + 'px' }">
    <!-- Fundo do círculo -->
    <svg class="transform -rotate-90" :width="size" :height="size">
      <circle
        :r="radius"
        :cx="size / 2"
        :cy="size / 2"
        class="text-gray-300"
        stroke-width="10"
        fill="transparent"
        stroke="currentColor" />
      <circle
        :r="radius"
        :cx="size / 2"
        :cy="size / 2"
        :stroke="progressColor"
        stroke-width="10"
        fill="transparent"
        :stroke-dasharray="circumference"
        :stroke-dashoffset="dashOffset"
        stroke-linecap="round"
        class="transition-all duration-500" />
    </svg>

    <!-- Texto no centro -->
    <div class="absolute text-center text-sm font-medium" :class="textColor">
      <!-- <div>{{ remainingMinutes }} min</div> -->
    </div>
  </div>
</template>

<script setup>
import { computed } from 'vue'

const props = defineProps({
  deadline: { type: String, required: true }, // ISO string
  currentTime: { type: String, required: true }, // ISO string
  size: { type: Number, default: 100 },
})

const TWO_HOURS_MS = 2 * 60 * 60 * 1000

const deadlineDate = computed(() => new Date(props.deadline))
const currentDate = computed(() => new Date(props.currentTime))

const remainingMs = computed(() => deadlineDate.value - currentDate.value)
const remainingMinutes = computed(() => Math.max(0, Math.floor(remainingMs.value / 60000)))

const withinTwoHours = computed(() => remainingMs.value <= TWO_HOURS_MS && remainingMs.value > 0)
const expired = computed(() => remainingMs.value <= 0)

const progress = computed(() => {
  if (!withinTwoHours.value) return 0
  return 1 - remainingMs.value / TWO_HOURS_MS
})

const radius = computed(() => (props.size - 10) / 2)
const circumference = computed(() => 2 * Math.PI * radius.value)
const dashOffset = computed(() => circumference.value * (1 - progress.value))

const progressColor = computed(() => {
  if (expired.value) return 'red'
  if (withinTwoHours.value) return 'orange'
  return 'green'
})

const textColor = computed(() => {
  if (expired.value) return 'text-red-500'
  if (withinTwoHours.value) return 'text-yellow-500'
  return 'text-green-500'
})
</script>
